import React, { Component } from "react";

import "./Dropzones.css";

import upload from "@safecv/assets/Images/upload.png";
import MESSAGE from "@safecv/shared/message";

const customDropzoneStyle = {
  height: "189px",
  background: "#ebf8ff",
  border: "2px dashed #bdbdbd",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  flexDirection: "column",
  fontSize: "16px",
  margin: "30px 20px",
};

class Dropzones extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hightlight: false,
      selectedUploadedFile: "",
      filename: "",
      acceptFile: null,
    };
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    if (typeof this.props.isOriginalPlan === "boolean" || this.props.reRun) {
      this.setState({ acceptFile: "application/pdf" });
    } else {
      this.setState({
        acceptFile:
          "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword",
      });
    }
  }

  openFileDialog = () => {
    if (this.props.disabled) return;
    this.fileInputRef.current.click();
  };

  onFilesAdded = (files) => {
    if (this.props.disabled) return;
    const file = files[0];
    if (file.type === "application/pdf") {
      this.props.updateUploadedFile(file);
      this.props.updateError(false);
      document.getElementById("Dropzones").style.border = "2px dashed #BDBDBD";
      document.getElementById("Dropzones").style.background = "#fff";
      document.getElementById("errorMSGFile").style.display = "none";
      document.getElementById("errorMSGFileDoc").style.display = "none";
      this.setState({
        selectedUploadedFile: file,
        filename: file.name,
      });
    } else {
      this.props.updateUploadedFile(null);
      this.props.updateError(true);
      this.setState({
        selectedUploadedFile: "",
        filename: "",
      });
      document.getElementById("Dropzones").style.border = "2px dashed #FEB2B2";
      document.getElementById("Dropzones").style.background = "#FFF5F5";
      document.getElementById("errorMSGFile").style.display = "block";
      document.getElementById("errorMSGFileDoc").style.display = "none";
    }
  };

  onDragOver = (evt) => {
    evt.preventDefault();

    if (this.props.disabled) return;

    this.setState({ hightlight: true });
  };

  onDragLeave = () => {
    this.setState({ hightlight: false });
  };

  onDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    this.onFilesAdded(files);
    this.setState({ hightlight: false });
  };

  fileListToArray = (list) => {
    const array = [];
    for (var i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  };

  render() {
    let { filename, acceptFile } = this.state;
    if (this.props.supportDocVerify === false) {
      try {
        // Bulk upload input
        if (this.props.isOriginalPlan === null) {
          if (this.props.errorTriggered) {
            document.getElementById(
              "fileUpload-" + this.props.isAdditionalIndex
            ).value = "";
          }
          const docFile = document.getElementById(
            "fileUpload-" + this.props.isAdditionalIndex
          )?.value;
          filename = filename !== "" ? filename : docFile;
        }

        //Other upload inputs
        else {
          if (this.props.errorTriggered) {
            document.getElementById(
              "fileUpload-" + this.props.isOriginalPlan
            ).value = "";
          }
          const docFile = document.getElementById(
            "fileUpload-" + this.props.isOriginalPlan
          )?.value;
          filename = filename !== "" ? filename : docFile;
        }
      } catch (e) {
        console.error(MESSAGE.UPLOAD_ERROR);
      }
    }

    return (
      <div>
        <div
          id="Dropzones"
          // className={`Dropzone ${this.state.hightlight ? "Highlight" : ""}`}
          style={
            this.props.RetriggerDropzoneStyle
              ? this.props.RetriggerDropzoneStyle
              : customDropzoneStyle
          }
          onDragOver={this.onDragOver}
          onDragLeave={this.onDragLeave}
          onDrop={this.onDrop}
          onClick={this.openFileDialog}
          // style={{ cursor: this.props.disabled ? "default" : "pointer" }}
        >
          <input
            ref={this.fileInputRef}
            className="FileInput"
            type="file"
            accept={acceptFile}
            onChange={(e) => this.onFilesAdded(e.target.files)}
          />
          <img alt="upload" className="Icon" src={upload} />
          <span className="dz-txtstyl"> Drag & Drop a file here </span>
          <span className="dz-txtstyl"> Or </span>
          <label htmlFor="file">
            <button className="btnstyl">Choose File</button>
          </label>
          {filename !== "" && <label htmlFor="file">{filename}</label>}
        </div>
        <div id="errorMSGFile">
          Incorrect File Format, please Upload a PDF File
        </div>
        <div id="errorMSGFileDoc">
          Incorrect File Format, please Upload a PDF/DOC/DOCX File
        </div>
      </div>
    );
  }
}

export default Dropzones;
